import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Phone, MessageSquare, Mail } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { FAQ_ITEMS } from "@/lib/constants";

export default function FaqPage() {
  return (
    <div data-testid="faq-page" className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="hero-gradient text-white py-14">
          <div className="max-w-3xl mx-auto px-4 text-center">
            <h1 className="font-display text-4xl sm:text-5xl font-black">Frequently asked questions</h1>
            <p className="mt-3 text-white/90">Everything you need to know. If it's not here, just call or text.</p>
          </div>
        </div>
        <div className="max-w-3xl mx-auto px-4 py-12">
          <Accordion type="single" collapsible className="mb-12">
            {FAQ_ITEMS.map((f, i) => (
              <AccordionItem key={i} value={`q-${i}`} data-testid={`faq-page-item-${i}`}>
                <AccordionTrigger className="text-left font-bold text-lg hover:text-[#ff6b35] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#333] text-base">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="bg-[#fffbf0] border-l-[5px] border-[#ff6b35] rounded-r-xl p-6">
            <h3 className="font-display text-2xl font-extrabold">Still have questions?</h3>
            <p className="text-[#333] mt-2">We actually answer the phone.</p>
            <div className="mt-4 grid sm:grid-cols-3 gap-3 text-sm">
              <a href="tel:+12163062330" className="flex items-center gap-2 bg-white p-3 rounded-lg border border-[#1a1a1a]/10 hover:border-[#ff6b35]">
                <Phone size={16} className="text-[#ff6b35]" /> <span className="font-bold">(216) 306-2330</span>
              </a>
              <a href="sms:+12163062330" className="flex items-center gap-2 bg-white p-3 rounded-lg border border-[#1a1a1a]/10 hover:border-[#ff6b35]">
                <MessageSquare size={16} className="text-[#ff6b35]" /> <span className="font-bold">Text us</span>
              </a>
              <a href="mailto:bookings@comepickupmytrash.com" className="flex items-center gap-2 bg-white p-3 rounded-lg border border-[#1a1a1a]/10 hover:border-[#ff6b35]">
                <Mail size={16} className="text-[#ff6b35]" /> <span className="font-bold text-xs">hello@...</span>
              </a>
            </div>
          </div>

          <div className="mt-10 text-center">
            <Link to="/book">
              <Button data-testid="faq-book-btn" className="bg-[#ff6b35] hover:bg-[#ff8c42] text-white rounded-lg font-bold h-11 px-7">
                Book a pickup
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
